module.exports = __webpack_public_path__ + "return-orange.e87818ed1ef019bdfd3dc4ab423bbb57.svg";